var map = {
	"./0.jpg": 45739,
	"./1.jpg": 22972,
	"./2.jpg": 77325,
	"./3.jpg": 97046,
	"./4.jpg": 46478,
	"./5.jpg": 10173,
	"./6.jpg": 66120,
	"./7.jpg": 69118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19473;